// extracted by mini-css-extract-plugin
export var chip = "_bi-0";
export var filterDropdown = "_bi-5";
export var filterItem = "_bi-6";
export var icon = "_bi-1";
export var removeButton = "_bi-3";
export var removeIcon = "_bi-4";
export var separator = "_bi-2";